<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add / Remove Courses
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="scroll-y overflow" style="height: calc(100vh - 65px - 10px - 48px) !important;">
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <div class="filterSection">
        <v-text-field
          v-model="search"
          label="Search Courses"
          type="text"
          @change="applyCourseSearch"
          append-icon="fa-search"
          class="filter-user"
        ></v-text-field>
        <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </div>
        <v-expansion-panels accordion 
          v-model="panel"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Courses Assigned</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :options.sync="getEnrolledCourses"
                  :server-items-length="serverItemsLength"
                  v-show="!loading"
                  :items="courses"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                  :footer-props="{
                  'items-per-page-options': [5,10,15]
                  }"
                >
                  <template v-slot:item.name="{ item }">
                    <div class="course-title-wrapper">
                      <span class="ml-2">{{item.name}}</span>
                      <v-tooltip v-if="item.is_membership" bottom >
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class='isMember-Title'></div>
                        </template>
                        <span>Membership Content</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:item.published="{ item }">
                    <v-icon v-if="item.published" color="green">fa-check</v-icon>
                    <v-icon v-else color="red">fa-times</v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <v-expansion-panels accordion 
          v-model="panel2"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Courses Unassigned</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                  v-model="selected2"
                  :headers="headers"
                  :options.sync="getUnEnrolledCourses"
                  :server-items-length="serverItemsLength2"
                  v-show="!loading2"
                  :items="courses2"
                  show-select
                  item-key="id"
                  class="mb-5 enrol-user-list-tbl"
                  :footer-props="{
                  'items-per-page-options': [5,10,15]
                  }"
                  :item-disabled="item => item.is_course_archived"
                  @toggle-select-all="selectAllToggle"
                >
                  <template v-slot:item.name="{ item }">
                    <div class="course-title-wrapper">
                      <span class="ml-2">{{item.name}}</span>
                      <v-tooltip v-if="item.is_membership" bottom >
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class='isMember-Title'></div>
                        </template>
                        <span>Membership Content</span>
                      </v-tooltip>
                      <v-tooltip v-if="item.is_course_archived" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              class="ml-1"
                              text
                              color="$improve-grey-900"
                              style="width: auto; cursor: auto;"
                            >
                              <v-icon x-small>fa fa-question</v-icon>
                            </v-btn>
                          </template>
                          <span>This course cannot be assigned because it has been archived.</span
                          >
                        </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:item.published="{ item }">
                    <v-icon v-if="item.published" color="green">fa-check</v-icon>
                    <v-icon v-else color="red">fa-times</v-icon>
                  </template>
                  <template
                        v-slot:item.data-table-select="{
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <v-simple-checkbox
                          :value="isSelected"
                          :readonly="item.is_course_archived"
                          :disabled="item.is_course_archived"
                          @input="select($event)"
                          :ripple=false
                        ></v-simple-checkbox>
                      </template>
                        
                </v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button"  @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-2 add-course-button" @click="saveModules">Save Courses</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import channelAPI from "@/api/channel.js";

export default {
  name: "ChannelModules",
  components: {
    
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "name" },
        {
          text: "Published",
          value: "published",
          sortable: false,
          align: "center"
        }
      ],
      courses: [],
      search: "",
      pagination: {},
      getEnrolledCourses: {},
      getUnEnrolledCourses: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      channel: [],
      modules: {},
      topics: [],
      courses2: [],
      selected2: [],
      loading2: false,
      successMessage: "Playlist Courses Saved",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      panel: [0,1],
      panel2: [0,1],
      count:0,
      serverItemsLength:0,
      serverItemsLength2:0,
      categories: [],
      selectedCategory: [],
    };
  },
  computed: {
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.getEnrolledCourses, this.serverItemsLength);
    },
    paramsPart2: function() {
      return this.$gf.getQueryString(this.getUnEnrolledCourses, this.serverItemsLength2);
    },
    selectedArray: function() {
      let assignedCourses = [];
      this.selected.map(x => {
        assignedCourses.push(x.id);
      });

      if(this.selected2.length > 0) {
        this.selected2.forEach(function(x) {
          assignedCourses.push(x.id);
        });
      }
      return assignedCourses;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    getEnrolledCourses: {
      handler() {
        this.getAllEnrolledCourses();
      },
      deep: true
    },
    getUnEnrolledCourses: {
      handler() {
        this.getAllUnEnrolledCourses();
      },
      deep: true
    }
  },
  mounted() {
    this.getChannel();
    this.getAllCourseCategories();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    saveModules() {
      this.loading = true;
      
      channelAPI
        .saveModules(this.id, {
          modules: this.selectedArray
        })
        .then(() => {
          EventBus.$emit("CHANNELS_UPDATED", this.params);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getChannel() {
      this.loading = true;
      channelAPI.getChannel(this.id, "?include=modules").then(response => {
        this.loading = false;
        this.selected = response.data.data.modules.data;
      });
    },
    getAllEnrolledCourses() {
      this.loading = true;
      courseAPI.getEnrolledChannelCourses(this.params+this.searchParams, this.id).then(response => {
        this.loading = false;
        this.courses = response.data.data;
        // this.selected = response.data.data;  
        this.serverItemsLength = response.data.meta.pagination.total;
      });
    },
    getAllUnEnrolledCourses() {
      this.loading2 = true;
      courseAPI.getUnenrolledChannelCourses(this.paramsPart2+this.searchParams, this.id).then(response => {
        this.loading2 = false;
        this.courses2 = response.data.data;
        this.serverItemsLength2 = response.data.meta.pagination.total;
      });
    },
    /*getUnAssignedCourses() {
      
      channelAPI.getChannel(this.id, "?include=unassigndCourses").then(response => {
        this.courses2 = response.data.data.unassigndCourses.data;
        //this.courses = response.data.data.unassigndCourses.data;
      });   
    },*/
    applyCourseSearch() {
      this.getEnrolledCourses.page = 1;
      this.getUnEnrolledCourses.page = 1;
      this.searchParams = '';
      
      this.searchParams = this.search && this.search.length > 0
      ? '&search=name:' + this.search : '';
      
      if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }

      this.getAllEnrolledCourses();
      this.getAllUnEnrolledCourses();
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.applyCourseSearch();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    selectAllToggle({ value, items }) {
      if (value) {
        // Only select non-archived items
        const nonArchivedItems = items.filter(item => !item.is_course_archived);

        // Replace the selected2 with only non-archived ones
        this.selected2 = [...this.selected2, ...nonArchivedItems.filter(
          newItem => !this.selected2.some(sel => sel.id === newItem.id)
        )];
      } else {
        // Deselect only the visible, non-archived items
        const idsToRemove = items
          .filter(item => !item.is_course_archived)
          .map(item => item.id);

        this.selected2 = this.selected2.filter(
          selected => !idsToRemove.includes(selected.id)
        );
      }
    },
  }
};
</script>
<style scoped>
.course-title-wrapper {
    display: flex;
    justify-content: left !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 1em;
}

.isMember-Title::after {
    content: "";
    width: 15px;
    height: 14px;
    margin: 4px 1px 0px 0px;
    background-image: url(/static/safeguarding-stars.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
}

.isMember-Title {
    background-color: #83c902;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
}
</style>